export default "__VITE_ASSET__BsarbK13__"